import { HttpLink, split } from '@apollo/client'

import { API } from 'Config'
import Utils from 'Utils'

import { createWsLink } from './createWsLink'

export function createChatLink() {
  const isSubscription = Utils.ApolloClient.isSubscription

  const wsLink = createWsLink({ url: `${API.CHAT_WS}/graphql` })
  const httpLink = new HttpLink({ uri: `${API.CHAT_URL}/graphql` })

  return split(isSubscription, wsLink, httpLink)
}
